import { roles } from "../config/config";

export const requestsPermissions = [
  roles.admin,
  roles.gestore,
  roles.developer,
  roles.magazziniere,
  roles.grafico,
];

export const getRequestsPermissions = (userIsAgente) => [
  ...requestsPermissions,
  userIsAgente,
];
